const confimeaDictPT = {
  headerPartnership: "Parceria",
  headerHelp: "Ajuda",
  headerBackToConfimea: "Voltar ao site da Confimea",
  heroBadge: "Bem-vindo ao Business Square da Confimea Imprese",
  heroTitle: "Ative seu acesso digital",
  heroTitleSpan: "no Business Square",
  heroText: "Se sua empresa está associada à Confimea Imprese, solicite o acesso Manager e comece imediatamente a aproveitar os processos digitais no Business Square.",
  heroButton: "SOLICITAR ATIVAÇÃO MANAGER",
  heroStat1Value: "500+",
  heroStat1Label: "Empresas ativas",
  heroStat2Value: "24h",
  heroStat2Label: "Ativação rápida",
  heroStat3Value: "98%",
  heroStat3Label: "Satisfação dos clientes",
  benefitsBadge: "VANTAGENS EXCLUSIVAS",
  benefitsTitle: "Por que ativar o perfil Manager na plataforma Business Square?",
  benefitsSubtitle: "Ferramentas pensadas para digitalizar e fazer crescer sua empresa associada na rede digital.",
  benefit1Title: "Presença digital estruturada",
  benefit1Text: "Crie o perfil da sua empresa e gerencie a visibilidade online com ferramentas simples e dedicadas.",
  benefit2Title: "CashBack e fidelização",
  benefit2Text: "Integre programas de fidelização para incentivar os clientes a voltarem e aumentar as vendas.",
  benefit3Title: "Suporte dedicado Confimea",
  benefit3Text: "Acesse um suporte prioritário dedicado aos membros Confimea Imprese para todas as necessidades.",
  benefit4Title: "Analytics e relatórios",
  benefit4Text: "Monitore o desempenho da sua atividade com dashboards intuitivos e relatórios detalhados.",
  benefit5Title: "Rede Business Square",
  benefit5Text: "Faça parte de uma rede de empresas e acesse oportunidades de negócios e networking.",
  benefit6Title: "Certificação digital",
  benefit6Text: "Obtenha badges e certificações que comprovam sua pertença à rede Confimea.",
  benefitLink: "Saiba mais",
  benefitsInfoBannerText: "Precisa de mais informações?",
  benefitsInfoBannerText2: "Entre em contato com nossa equipe e ajudaremos você a começar.",
  benefitsInfoBannerButton: "Entre em contato com o suporte",
  howItWorksBadge: "PROCESSO SIMPLES",
  howItWorksTitle: "Como funciona a ativação do perfil Manager?",
  howItWorksSubtitle: "Três passos simples para ativar a digitalização da sua empresa associada.",
  step1Title: "Preencha o formulário",
  step1Text: "Insira os dados da sua empresa e as informações solicitadas para verificação.",
  step1Link: "2 minutos",
  step2Title: "Verificação e aprovação",
  step2Text: "Seu perfil será verificado pela equipe para confirmar sua pertença.",
  step2Link: "24-48 horas",
  step3Title: "Ativação imediata",
  step3Text: "Receba o acesso à plataforma e comece imediatamente a gerenciar sua atividade.",
  step3Link: "Imediato",
  ctaBadge: "Comece hoje mesmo",
  ctaTitle: "Pronto para começar?",
  ctaText: "Com alguns passos simples você pode ativar o acesso à plataforma Business Square e começar a gerenciar sua atividade de forma digital e profissional.",
  ctaButton: "Preencha o formulário",
  formBadge: "Cadastro rápido",
  formTitle: "Solicite o acesso Manager",
  formSubtitle: "Preencha o formulário e em 24 horas você receberá a ativação da sua conta como Manager na plataforma.",
  formCompanyLabel: "Nome da Empresa/Entidade",
  formCompanyPlaceholder: "Ex. Consultório Médico Rossi",
  formNameLabel: "Nome e Sobrenome",
  formNamePlaceholder: "Mario Rossi",
  formEmailLabel: "Email corporativo",
  formEmailPlaceholder: "nome@empresa.com",
  formPasswordLabel: "Senha",
  formPasswordPlaceholder: "Crie uma senha segura",
  formPartnerCodeLabel: "Código Parceiro",
  formPartnerCodeOptional: "(opcional)",
  formPartnerCodePlaceholder: "Se você tiver um código parceiro, insira-o aqui",
  formAcceptTerms: "Aceito os",
  formTermsLink: "Termos e Condições",
  formAnd: "e a",
  formPrivacyLink: "Política de Privacidade",
  formTermsSuffix: "do Business Square.",
  formAcceptMarketing: "Consinto em receber comunicações comerciais e atualizações sobre os serviços.",
  formSubmit: "Enviar solicitação de ativação",
  formCaptcha: "Protegido por reCAPTCHA - Privacidade e Termos do Google",
  partnershipBadge: "Parceria oficial",
  partnershipTitle: "Parceria oficial",
  partnershipSubtitle: "Um canal dedicado exclusivamente às empresas associadas à Confimea Imprese para acessar digitalização e funcionalidades ativas.",
  partnershipLink1: "Ver todas as vantagens",
  partnershipLink2: "Cadastre-se agora",
  faqBadge: "FAQ",
  faqTitle: "Perguntas frequentes",
  faqSubtitle: "Encontre respostas para as perguntas mais comuns sobre a parceria e a ativação.",
  faq1Question: "Quem pode acessar ao ativar uma ativação?",
  faq1Answer:
    "Apenas empresas oficialmente associadas à Confimea Imprese podem preencher este formulário. Durante o processo de verificação, verificaremos cuidadosamente o código associado fornecido para confirmar a pertença à rede e garantir o acesso aos benefícios exclusivos da parceria.",
  faq2Question: "O serviço ativo/assistência está incluído no plano Manager?",
  faq2Answer:
    "Não. Após o envio do formulário, nossa equipe verifica cuidadosamente os dados e a associação à Confimea Imprese. Posteriormente, entraremos em contato para completar a ativação e fornecer as credenciais de acesso. O processo de verificação normalmente leva 24-48 horas úteis, mas trabalhamos para ser o mais rápido possível.",
  faq3Question: "É necessário pessoal técnico para usar a plataforma?",
  faq3Answer:
    "Absolutamente não. O Business Square foi projetado especificamente para gestores de empresas, com uma interface intuitiva e fácil de usar. Não é necessária nenhuma experiência técnica particular. Além disso, oferecemos treinamento inicial completo e suporte dedicado para todos os novos Managers, garantindo um onboarding fluido e produtivo.",
  faq4Question: "Quais são os custos associados ao plano Manager?",
  faq4Answer:
    "Para empresas associadas à Confimea Imprese, o plano Manager inclui condições especiais acordadas na parceria. Nossa equipe fornecerá todos os detalhes sobre custos e condições durante o processo de ativação, juntamente com uma apresentação completa das funcionalidades disponíveis.",
  faq5Question: "Posso cancelar o acesso Manager a qualquer momento?",
  faq5Answer:
    "Sim, você tem total liberdade para gerenciar seu acesso. Você pode solicitar a suspensão ou cancelamento a qualquer momento entrando em contato com o suporte dedicado. Não há vínculos contratuais rígidos, e nosso objetivo é sempre garantir a máxima satisfação e flexibilidade para os parceiros.",
  contactTitle: "Tem outras perguntas?",
  contactText: "Nossa equipe está pronta para ajudá-lo e responder a todas as suas perguntas em tempo real.",
  contactButton1: "Entre em contato agora",
  contactButton2: "Ir para FAQ",
  footerPartnership: "Parceria",
  footerLink1: "Para Empresas Associadas",
  footerLink2: "Como funciona",
  footerLink3: "FAQ",
  footerQuickLinks: "Links rápidos",
  footerLink4: "Site Extraconomy",
  footerLink5: "Solicitar acesso",
  footerLink6: "Suporte",
  footerContacts: "Contatos",
  footerCopyright: "Extraconomy Global srl - P.IVA 16948681008 - Todos os direitos reservados",
  email: "Email",
  fullName: "Nome completo",
  formSuccessBadge: "Registro concluído",
  formSuccessTitle: "Verifique seu email",
  formSuccessSubtitle: "Enviamos um link de confirmação para seu email. Clique no link para ativar seu conta Manager e começar a usar a plataforma Business Square.",
  formSuccessMessage: "Enviamos um email de confirmação para:",
  formSuccessNote: "Por favor, verifique sua caixa de entrada e ative sua conta através do link enviado no email.",
  formSuccessStep1: "Abra o email que enviamos para você",
  formSuccessStep2: "Clique no botão de confirmação",
  formSuccessStep3: "Você será redirecionado para o login da plataforma",
  formSuccessEmailNotReceived:
    "Não recebeu o email? Verifique sua pasta de spam.",
  emailVerified: "Email Verificado!",
  completeActivationSubtitle: "Complete a ativação enviando a documentação solicitada",
  requiredDocuments: "Documentos Necessários para a ativação completa",
  document1: "Para completar a validação da sua inscrição na Confimea Imprese na Business Square, iremos solicitar estes documentos.",
  document2: "Você pode prepará-los e enviá-los com calma: não é necessário fazê-lo imediatamente.",
  document3: "Baixe o formulário, preencha-o e assine-o. Você poderá carregar o formulário e os outros documentos na sua área pessoal quando for mais conveniente para você.",
  downloadTemplateDocument: "BAIXAR DOCUMENTO MODELO",
  uploadYourDocuments: "Carregue seus documentos",
  uploadedFiles: "Arquivos carregados",
  ready: "Pronto",
  chooseFile: "Escolher arquivo",
  dragFilesHereOrClick: "Arraste os arquivos aqui ou clique para selecionar",
  fileFormatsHint: "PDF, JPG, PNG (Máx 10MB por arquivo)",
  documentsVerificationInfo: "Os documentos serão verificados em até 24 horas úteis. Você receberá uma confirmação por email.",
  skipAndGoToLogin: "PULAR E IR PARA O LOGIN",
  sendDocumentation: "ENVIAR DOCUMENTAÇÃO",
  privacyNote: "Seus documentos serão tratados de forma confidencial de acordo com as normas GDPR.",
  confirmingEmail: "Confirmando email...",
  confirmationMissingParams: "Parâmetros de confirmação ausentes",
  confirmationError: "Erro ao confirmar email",
  fileUploadedSuccessfully: "Arquivo carregado com sucesso",
  pleaseUploadDocument: "Por favor, carregue um documento",
  documentSentSuccessfully: "Documentação enviada com sucesso",
  confirmationDocumentDescription: "Documentação de ativação Confimea Imprese",
  goToLogin: "Ir para Login",
  removeFile: "Remover",
  documentsReceived: "DOCUMENTOS RECEBIDOS",
  documentationSentSuccessfully: "Documentação enviada com sucesso!",
  documentationSentSuccessfullySubtitle: "Obrigado por enviar seus documentos. Nossa equipe de verificação iniciará o processo de validação.",
  emailConfirmation: "Confirmação via email",
  emailConfirmationDescription: "Você receberá um email de confirmação de recebimento no endereço fornecido.",
  verificationTime: "Tempo de verificação",
  verificationTimeDescription: "O processo de verificação geralmente leva 24-48 horas úteis.",
  activationNotification: "Notificação de ativação",
  activationNotificationDescription: "Uma vez aprovado, você receberá as credenciais de acesso por email.",
  whatHappensNow: "O que acontece agora?",
  whatHappensNow1: "A equipe Confimea Imprese verificará os documentos enviados",
  whatHappensNow2: "Se necessário, podemos entrar em contato para esclarecimentos adicionais",
  whatHappensNow3: "Você receberá as credenciais de acesso à plataforma Manager",
  whatHappensNow4: "Você poderá começar a gerenciar seus clientes e seus documentos",
  goToLoginPage: "IR PARA A PÁGINA DE LOGIN",
  associationDocumentUnavailable:
    "Não foi possível carregar o documento da associação. Tente novamente mais tarde.",
  paymentSummary: "Resumo da operação:",
  preferPayPal: "Se preferir, pague com PayPal",
};

export default confimeaDictPT;

